// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"X","arrowBtnBox":"X","arrow-btn-wrap-box":"Y","arrowBtnWrapBox":"Y","arrow-btn-text":"Z","arrowBtnText":"Z","arrow-btn-arrow":"aa","arrowBtnArrow":"aa"};